export enum CheckPluginStatusesEnum {
  AGREE = 'AGREE',
  DISAGREE = 'DISAGREE',
  IGNORED = 'IGNORED',
}
